import i18nService from "@/services/i18n"

export class SupportMeasure {
    id: number
    isActive: boolean
    code: string
    nameRu: string
    nameKk: string
    
    get name(): string {
        if (i18nService.locale === 'kk') {
            return this.nameKk
        }
        return this.nameRu
    }

    constructor(
        id: number,
        code: string,
        nameRu: string,
        nameKk: string,
    ) {
        this.id = id
        this.code = code
        this.nameRu = nameRu
        this.nameKk = nameKk
        this.isActive = false
    }
}
